import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LayoutDashboard, Package, MessageSquare, FileText, LogOut, ArrowLeft, Settings, Star, Globe } from 'lucide-react';

const sidebarLinks = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { to: '/admin/products', label: 'Products', icon: Package },
  { to: '/admin/quotes', label: 'Quotes', icon: MessageSquare },
  { to: '/admin/articles', label: 'Articles', icon: FileText },
  { to: '/admin/testimonials', label: 'Testimonials', icon: Star },
  { to: '/admin/content', label: 'Site Content', icon: Globe },
  { to: '/admin/settings', label: 'Settings', icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const isActive = (link) => {
    if (link.exact) return location.pathname === link.to;
    return location.pathname.startsWith(link.to);
  };

  return (
    <div className="min-h-screen flex bg-gray-50" data-testid="admin-layout">
      <aside className="w-64 bg-[#0A0A0A] text-white flex flex-col flex-shrink-0">
        <div className="p-6 border-b border-gray-800">
          <h2 className="text-[#D4AF37] text-lg font-bold" style={{ fontFamily: "'Poppins', sans-serif" }}>SBE Admin</h2>
          <p className="text-xs text-gray-500 mt-1">{user?.email}</p>
        </div>
        <nav className="flex-1 py-4">
          {sidebarLinks.map(link => (
            <Link key={link.to} to={link.to} className={`admin-sidebar-link flex items-center gap-3 px-6 py-3 text-sm ${isActive(link) ? 'active text-[#D4AF37]' : 'text-gray-400'}`} data-testid={`admin-nav-${link.label.toLowerCase()}`}>
              <link.icon size={18} />
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t border-gray-800 space-y-2">
          <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-white text-sm px-2 py-2" data-testid="admin-back-to-site">
            <ArrowLeft size={16} /> Back to Site
          </Link>
          <button onClick={handleLogout} className="flex items-center gap-2 text-gray-400 hover:text-red-400 text-sm px-2 py-2 w-full" data-testid="admin-logout">
            <LogOut size={16} /> Logout
          </button>
        </div>
      </aside>
      <div className="flex-1 overflow-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
